import { render, staticRenderFns } from "./helpCenterDetails.vue?vue&type=template&id=719f2f14&scoped=true&"
import script from "./helpCenterDetails.vue?vue&type=script&lang=js&"
export * from "./helpCenterDetails.vue?vue&type=script&lang=js&"
import style0 from "./helpCenterDetails.vue?vue&type=style&index=0&id=719f2f14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719f2f14",
  null
  
)

export default component.exports